import { styled } from "@mui/material/styles";
import { TableContainer } from "@mui/material";

export const CustomTableContainer = styled(TableContainer)(() => ({
  borderRadius: "8px",borderRadius: "8px",
  minHeight: '10vh'
}));